import Twemoji from './Twemoji';
import StickerCard from './StickerCard';
import ProgressBar from './ProgressBar';
import { applyGridFilter } from '../utils/gridFilter';

/**
 * A team block within a group view: header (flag, name, progress) + a grid
 * of StickerCards. Respects the current gridFilter — if no stickers pass
 * the filter the entire block is hidden so empty headers don't dangle.
 */
export default function TeamBlock({
  team,
  collected,
  duplicates,
  onToggle,
  onDupChange,
  getProgress,
  highlightedSticker,
  rarityMap,
  gridFilter,
  gridLayout,
  state,
  isIncoming,
}) {
  const progress = getProgress(team.stickers);
  const visibleStickers = applyGridFilter(team.stickers, gridFilter, state);
  if (visibleStickers.length === 0) return null;
  return (
    <div className="team-block" id={`team-${team.code}`}>
      <div className="team-header">
        <span className="flag"><Twemoji emoji={team.flag} /></span>
        <h3>{team.name}</h3>
        <div className="team-progress">
          <ProgressBar pct={progress.pct} />
          <span>{progress.have} / {progress.total}</span>
        </div>
      </div>
      <div className={`sticker-grid${gridLayout === 'list' ? ' compact' : ''}`}>
        {visibleStickers.map(s => (
          <StickerCard
            key={s.number} sticker={s}
            collected={!!collected[s.number]}
            duplicates={duplicates[s.number]}
            onToggle={onToggle} onDupChange={onDupChange}
            isHighlighted={highlightedSticker === s.number}
            rarity={rarityMap?.[s.number]}
            incoming={isIncoming ? isIncoming(s.number) : false}
          />
        ))}
      </div>
    </div>
  );
}
